function setupAiStepsMotion(root) {
    const section = root.querySelector('.topic-ai-steps');
    if (!section) return undefined;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;
    const page = root.querySelector('.topic-v2-ai');
    const cards = [...section.querySelectorAll('.topic-ai-step-card')];
    const pageTargets = [...page.querySelectorAll([
        '.topic-ai-steps-heading',
        '.topic-v3-narrative > section',
        '.topic-v3-case',
        '.topic-v3-focus-list li',
        '.topic-v3-knowledge-items article',
        '.topic-v2-faq',
        '.topic-v2-bottom-cta',
        '.topic-v2-related',
    ].join(','))];
    section.classList.add('is-motion-ready');
    page.classList.add('topic-ai-page-motion-ready');
    pageTargets.forEach(target => target.classList.add('topic-ai-reveal'));
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
        });
    }, { threshold: 0.08, rootMargin: '0px 0px -8% 0px' });
    cards.forEach(card => observer.observe(card));
    pageTargets.forEach(target => observer.observe(target));
    return () => {
        observer.disconnect();
        section.classList.remove('is-motion-ready');
        page.classList.remove('topic-ai-page-motion-ready');
    };
}

module.exports = setupAiStepsMotion;
